// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OKvGYf {
  max-width: min(520px, 92vw);
  width: min(100%, 520px);
  max-height: min(90vh, 720px);
}

.qCW7Si {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding-top: 0;
}

.fgw2jv {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  gap: var(--spacing-3, 24px);
}

.exym1m {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-1, 8px) var(--spacing-3, 24px) 0 var(--spacing-3, 24px);
  flex-shrink: 0;
}

.IVoM1T {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.TJq0f7 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-sm, 14px);
  line-height: 1.4;
  color: var(--text-neutral-secondary, #666666);
  margin: 0;
}

@media (max-width: 768px) {
  .exym1m {
    padding: var(--spacing-1, 8px) var(--spacing-2, 16px) 0 var(--spacing-2, 16px);
  }
}

.jaUfZV {
  flex: 1 1 auto;
  min-height: 120px;
  max-height: min(45vh, 360px);
  padding: 0 var(--spacing-2, 16px) var(--spacing-2, 16px);
  border: 1px solid #d1d5db;
  border-radius: var(--radius-s, 8px);
  background: var(--surface-neutral-white, #ffffff);
  box-sizing: border-box;
  overflow-y: auto;
}

.VM6iYW {
  padding: 0;
}

.bHNXRm {
  padding: 0;
}

.UTdSVM {
  padding: 14px 10px;
  box-sizing: border-box;
  min-height: 0;
}

.x_34zO {
  flex: 1 1 auto;
  min-height: min(45vh, 360px);
}

.Rmvmxg {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  padding: 14px 10px;
  box-sizing: border-box;
}

.k3pz8J {
  display: block;
  flex: 1 1 auto;
  min-height: 120px;
  width: 100%;
  border: 0;
  border-radius: var(--radius-s, 8px);
  background: var(--surface-neutral-white, #ffffff);
}

.C8Tuiu {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-sm, 14px);
  line-height: 1.5;
  color: var(--text-neutral-dark, #333333);
}

.C8Tuiu h1 {
  font-size: 16px;
  text-align: left;
  font-weight: var(--font-weight-semibold, 600);
  margin: 0 0 0.5em;
  line-height: 1.3;
}

.C8Tuiu h2 {
  font-size: 15px;
  text-align: left;
  font-weight: var(--font-weight-semibold, 600);
  margin: 0 0 0.5em;
  line-height: 1.3;
}

.C8Tuiu p {
  margin: 0 0 0.75em;
  font-size: 13px;
}

.C8Tuiu p:last-child {
  margin-bottom: 0;
}

.C8Tuiu strong,
.C8Tuiu b {
  font-weight: var(--font-weight-semibold, 600);
}

.mfeRg9 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-3, 24px);
  width: 100%;
}

.rl8Vvh {
  margin-left: auto;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .mfeRg9 {
    flex-direction: column;
    align-items: stretch;
  }

  .rl8Vvh {
    margin-left: 0;
    align-self: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/TermsAcceptanceModal/TermsAcceptanceModal.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,8EAA8E;EAC9E,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE;IACE,8EAA8E;EAChF;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,wDAAwD;EACxD,yBAAyB;EACzB,mCAAmC;EACnC,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;AACF","sourcesContent":[".modal {\n  max-width: min(520px, 92vw);\n  width: min(100%, 520px);\n  max-height: min(90vh, 720px);\n}\n\n.modalBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  padding-top: 0;\n}\n\n.termsChrome {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  gap: var(--spacing-3, 24px);\n}\n\n.termsHeader {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-1, 8px) var(--spacing-3, 24px) 0 var(--spacing-3, 24px);\n  flex-shrink: 0;\n}\n\n.visuallyHidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.termsSubtitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-sm, 14px);\n  line-height: 1.4;\n  color: var(--text-neutral-secondary, #666666);\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .termsHeader {\n    padding: var(--spacing-1, 8px) var(--spacing-2, 16px) 0 var(--spacing-2, 16px);\n  }\n}\n\n.scrollBox {\n  flex: 1 1 auto;\n  min-height: 120px;\n  max-height: min(45vh, 360px);\n  padding: 0 var(--spacing-2, 16px) var(--spacing-2, 16px);\n  border: 1px solid #d1d5db;\n  border-radius: var(--radius-s, 8px);\n  background: var(--surface-neutral-white, #ffffff);\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.scrollBoxNoInset {\n  padding: 0;\n}\n\n.scrollBoxWithIframe {\n  padding: 0;\n}\n\n.termsDocumentOuter {\n  padding: 14px 10px;\n  box-sizing: border-box;\n  min-height: 0;\n}\n\n.termsLinkLoading {\n  flex: 1 1 auto;\n  min-height: min(45vh, 360px);\n}\n\n.termsIframeShell {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  padding: 14px 10px;\n  box-sizing: border-box;\n}\n\n.termsIframe {\n  display: block;\n  flex: 1 1 auto;\n  min-height: 120px;\n  width: 100%;\n  border: 0;\n  border-radius: var(--radius-s, 8px);\n  background: var(--surface-neutral-white, #ffffff);\n}\n\n.termsDocument {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-sm, 14px);\n  line-height: 1.5;\n  color: var(--text-neutral-dark, #333333);\n}\n\n.termsDocument :global(h1) {\n  font-size: 16px;\n  text-align: left;\n  font-weight: var(--font-weight-semibold, 600);\n  margin: 0 0 0.5em;\n  line-height: 1.3;\n}\n\n.termsDocument :global(h2) {\n  font-size: 15px;\n  text-align: left;\n  font-weight: var(--font-weight-semibold, 600);\n  margin: 0 0 0.5em;\n  line-height: 1.3;\n}\n\n.termsDocument :global(p) {\n  margin: 0 0 0.75em;\n  font-size: 13px;\n}\n\n.termsDocument :global(p:last-child) {\n  margin-bottom: 0;\n}\n\n.termsDocument :global(strong),\n.termsDocument :global(b) {\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--spacing-3, 24px);\n  width: 100%;\n}\n\n.footerConfirm {\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .footerConfirm {\n    margin-left: 0;\n    align-self: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OKvGYf`,
	"modalBody": `qCW7Si`,
	"termsChrome": `fgw2jv`,
	"termsHeader": `exym1m`,
	"visuallyHidden": `IVoM1T`,
	"termsSubtitle": `TJq0f7`,
	"scrollBox": `jaUfZV`,
	"scrollBoxNoInset": `VM6iYW`,
	"scrollBoxWithIframe": `bHNXRm`,
	"termsDocumentOuter": `UTdSVM`,
	"termsLinkLoading": `x_34zO`,
	"termsIframeShell": `Rmvmxg`,
	"termsIframe": `k3pz8J`,
	"termsDocument": `C8Tuiu`,
	"footer": `mfeRg9`,
	"footerConfirm": `rl8Vvh`
};
module.exports = ___CSS_LOADER_EXPORT___;
